import { CURRENCY, FIAT_CURRENCIES, STABLECOIN_CURRENCIES } from '~/types'

export const AccountCurrencyOrder: Record<CURRENCY, number> = {
  [CURRENCY.XSGD]: 1,
  [CURRENCY.XUSD]: 2,
  [CURRENCY.XIDR]: 3,
  [CURRENCY.USDT]: 4,
  [CURRENCY.USDC]: 5,
  [CURRENCY.USDP]: 6,
  [CURRENCY.SGD]: 7,
  [CURRENCY.USD]: 8,
  [CURRENCY.IDR]: 9,
}

const currenciesInOrder = ({
  currencies,
  order,
}: {
  currencies: CURRENCY[]
  order: Record<CURRENCY, number>
}) => {
  const copy = [...currencies]
  return copy.sort((a, b) => order[a] - order[b])
}

export const FIAT_CURRENCIES_IN_ORDER = currenciesInOrder({
  currencies: FIAT_CURRENCIES,
  order: AccountCurrencyOrder,
})

export const STABLECOIN_CURRENCIES_IN_ORDER = currenciesInOrder({
  currencies: STABLECOIN_CURRENCIES,
  order: AccountCurrencyOrder,
})
